import { Modal } from "react-bootstrap";
import {
  error50,
  error900,
  netural400,
  netural50,
  neturalBlack,
  success50,
  success900,
} from "../../constants/color";
import CustomLabel from "../shared/label/custom-label.component";
import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { FETCH_ALL_ORDER_SCHEDULE_DETAILS } from "../../services/graphql/subscription";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";
import UpdateOrderStatus from "../update-order-status-section/update-order-status-section.component";
// import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";

const SubscriptionOrderDetailsModal = (props) => {
  const { subscriptionid, selectedStatuses } = props;
  const [scheduleDetails, setScheduleDetails] = useState([]);

  useEffect(() => {
    if (subscriptionid) {
      fetchAllOrderScheduleDetails({
        variables: {
          subscriptionId: subscriptionid,
        },
      });
    }
  }, []);

  const [
    fetchAllOrderScheduleDetails,
    { loading: loadingOrderScheduleDetails },
  ] = useLazyQuery(FETCH_ALL_ORDER_SCHEDULE_DETAILS, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data && data.fetchAllOrderScheduleDetails) {
        const orderScheduleDetails = data.fetchAllOrderScheduleDetails;
        setScheduleDetails(orderScheduleDetails);
      }
    },
  });

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        // backdrop="static"
        className="login-modal-style"
      >
        <Modal.Header
          closeButton
          style={{
            borderBottom: "0px solid rgb(0, 0, 0, 0.1)",
            paddingLeft: "3%",
            paddingRight: "3%",
            backgroundColor: "white",
            borderRadius: "12px",
            paddingBottom: "0px",
            marginBottom: "2%",
          }}
        >
          <Modal.Title id="contained-modal-title-vcenter">
            <CustomLabel
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: neturalBlack,
              }}
            >
              Order details
            </CustomLabel>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            marginBottom: "2%",
            paddingLeft: "3%",
            paddingRight: "3%",
            paddingTop: "3%",
            borderTop: "solid 1px #dadada",
          }}
        >
          {loadingOrderScheduleDetails ? (
            <LoadingSpinner overlay={false} />
          ) : (
            scheduleDetails.map((orderInfo, index) => {
              return (
                <div key={index}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <CustomLabel
                      style={{
                        color: netural400,
                        fontWeight: "600",
                        fontSize: "14px",
                      }}
                    >
                      Order ID#{" "}
                      {orderInfo.status === "successful"
                        ? orderInfo.transactionId
                        : orderInfo.id}
                    </CustomLabel>
                    <CustomLabel
                      style={{
                        color: netural400,
                        fontSize: "14px",
                        marginTop: "1%",
                      }}
                    >
                      {orderInfo.orderDate}
                    </CustomLabel>
                    <div>
                      <CustomLabel
                        style={{
                          color:
                            orderInfo.status === "successful"
                              ? success900
                              : orderInfo.status === "cancelled" ||
                                orderInfo.status === "unsucccessful"
                              ? error900
                              : neturalBlack,
                          fontSize: "14px",
                          backgroundColor:
                            orderInfo.status === "successful"
                              ? success50
                              : orderInfo.status === "cancelled" ||
                                orderInfo.status === "unsucccessful"
                              ? error50
                              : netural50,
                          borderRadius: "12px",
                          paddingLeft: "2%",
                          paddingRight: "2%",
                          marginTop: "1%",
                          textTransform: "capitalize",
                        }}
                      >
                        {orderInfo.status}
                      </CustomLabel>
                    </div>
                    <UpdateOrderStatus
                      orderData={orderInfo}
                      handleStatusChange={(e) =>
                        props.handleStatusChange(
                          orderInfo.transactionId,
                          e.target.value
                        )
                      }
                      orderStatus={
                        selectedStatuses[orderInfo.transactionId] ||
                        orderInfo.status
                      }
                      handleButtonClick={() => {
                        props.handleUpdateStatusClick();
                      }}
                      loadingUpdateOrderStatus={false}
                      sectionTitle=""
                      sectionDescription="Let us know when your order has been delivered."
                      containerStyle={{ marginTop: "1%" }}
                    />
                  </div>
                  {scheduleDetails.length - 1 !== index && (
                    <div
                      style={{
                        border: "solid 1px #dadada",
                        marginTop: "2%",
                        marginBottom: "2%",
                      }}
                    ></div>
                  )}
                </div>
              );
            })
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubscriptionOrderDetailsModal;
